import { Component, OnInit } from '@angular/core';
import { MobileVehicleRelocationPhotosService } from 'src/app/services/mobile/mobile-vehicle-relocation-photos.service';
import { ToastrService } from 'ngx-toastr';
import {  Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-mobile-vehicle-transfer-photos',
  templateUrl: './mobile-vehicle-transfer-photos.component.html',
  styleUrls: ['./mobile-vehicle-transfer-photos.component.css']
})
export class MobileVehicleTransferPhotosComponent implements OnInit{
  public vehicle_id: string = '';
  public chassisNo: string|null = '';
  public logId:string|null='';
  public txnType:string|null='';
  public isLoading: boolean = false;
  public isUploading: boolean = false;
  form!: FormGroup;
  files: File[] = [];
  attachment: any;

  constructor(
    private vehicleRelocationPhotosService: MobileVehicleRelocationPhotosService,
    private toastr: ToastrService,
    private router: Router,
    private formBuilder: FormBuilder
  ){
    this.form = this.formBuilder.group({
      attachment: [null, Validators.required],
    });
   }

  ngOnInit(): void {
    this.chassisNo=localStorage.getItem('chassisNo');
    this.logId=localStorage.getItem('logId');
    this.txnType=localStorage.getItem('txnType');
  }

  //Select image
  onSelect(event: any) {
    this.files.push(...event.addedFiles);
  }

  //Remove image
  onRemove(event: any) {
    this.files.splice(this.files.indexOf(event), 1);
  }

  /**
    * Upload vehicle photos
    */
  handleSubmit(){
    if(this.files.length===0){
      this.toastr.error("Please select photos to proceed!", 'Error!');
    }else{
      this.isUploading=true;

      const formData = new FormData();
      this.files.forEach(file => {
        formData.append('photos[]', file);
      });

      this.vehicleRelocationPhotosService.uploadPhotos(formData,this.chassisNo,this.logId,this.txnType)
       .subscribe({
         next: (response) => {
           if(response.status==='success'){
             this.isUploading=false;
             this.toastr.success(response.message, 'Upload Successful!');

             //Cleared selected images
             this.files=[];

             //Redirect to recent transfers list
             this.router.navigate(['mobile/recent-transfers']);
           }else{
             this.isUploading=false;
             this.toastr.error(response.message, 'Error!!');
           }
         },
         error: (error) => {
           this.isUploading=false;
           this.toastr.error(error, 'Error!');
         }
       });
    }
  }
}
